<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Ingreso"
          directory="de solicitud"
          :icon="'trello'"
        />
      </div>

      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-table');
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
  </div>
</template>


<script>
// import CopyButton from "CopyButton";

export default {
  name: "Tabs",
//   components: { CopyButton },
  data() {
    return {
      icon: "settings",
      tabsHorizontal: [
        {
          icon: "activity",
          name: "Revisión de la Solicitud de Acreditación",
          component: "tab-verify",
          permission: "",
        },
        // {
        //   icon: "external-link",
        //   name: "Iniciar proceso de acreditación",
        //   component: "tab-process",
        //   permission: "",
        // },

        // {
        //   icon: "check-square",
        //   name: "Pre evaluaciones",
        //   component: "tab-evaluations",
        //   permission: "",
        // },
        
      ],
      
      //for copy dom code
      tabsHorizontalValue: `<app-tab :tabs="[
                    {
                        "icon": "send",
                        "name": "delivery",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "icon": "lock",
                        "name": "privacy",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "icon": "paperclip",
                        "name": "template",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "icon": "shield",
                        "name": "custom",
                        "component": "tab-setting",
                        "permission": ""
                    },
                    {
                        "icon": "bell",
                        "name": "notifications",
                        "component": "tab-setting",
                        "permission": ""
                    }
                ]" type="horizontal"/>`,

    };
  },
};
</script>
